<template>
  <b-form-group
    :id="'group' + customID"
    :class="`text-input-group ${requireError ? 'require-field' : ''}`"
    :label="`${$translate(placeholder)} ${required ? '*' : ''}`"
    :label-for="customID"
    :state="!isError"
    :invalid-feedback="errorMessage"
  >
    <div class="wrapper">
      <multiselect
        :id="customID"
        ref="team_multiselect"
        v-model="values"
        :options="options"
        :multiple="true"
        :close-on-select="true"
        :clear-on-select="false"
        :preserve-search="true"
        :max="limit"
        :placeholder="placeholderInput | i18n"
        :limit="displayLimit"
        :limit-text="(count) => `+${count}`"
        label="text"
        track-by="value"
        :class="`${values.length ? 'chosen-values' : ''}`"
        :disabled="disabled || viewMode"
      >
        <!-- <template slot="selection" slot-scope="{ values, search, isOpen }">
          <div v-if="values.length && !isOpen" class="single-wrapper">
            <span class="multiselect__single single-wrapper-text">
              {{ values.length }}
              {{ values.length > 1 ? selectedName.plural : selectedName.single | i18n }} {{ 'selected' | i18n }}
            </span>
          </div>
        </template> -->
        <template slot="option" slot-scope="{ option }">
          <Checkbox
            :value="values.some(({ value }) => value === option.value)"
            :placeholder="option.text"
            :form-group-id="option.value"
            :bottom="0"
            :input="(checkboxValue) => handleChoseValue({ optionValue: option, checkboxValue })"
            class="multiselect-checkbox"
          />
        </template>
      </multiselect>
    </div>
    <b-form-text>
      {{ bottomText }}
    </b-form-text>
  </b-form-group>
</template>

<script>
import Multiselect from 'vue-multiselect';

import Checkbox from '../checkbox';

export default {
  components: { Multiselect, Checkbox },
  props: {
    selectedName: {
      type: Object,
      default: () => ({ single: 'item', plural: 'items' }),
    },
    bottomText: {
      type: String,
      default: '',
    },
    customID: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    initValues: {
      type: [Array],
      default: () => [],
    },
    newValues: {
      type: [Array],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    placeholderInput: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    tileSize: {
      type: Number,
      default: 14,
    },
    limit: {
      type: Number,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    updateError: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      text: null,
      values: [],
      id: '',
      displayLimit: 99999,
    };
  },
  computed: {
    requireError: function () {
      return this.required && (!this.values || !this.values.length);
    },
    isError: function () {
      const error = this.error || this.requireError;
      this.updateError(error);
      return error;
    },
  },
  watch: {
    values: {
      async handler(newValue, oldValue) {
        await this.onChange(newValue);
        const multiselectTags = this.$refs.team_multiselect.$refs.tags;
        const tagsWidth = Number(multiselectTags.clientWidth) - 90;
        const optionsList = multiselectTags.children[0].children;
        let tagsWrapWidth = 0;
        [...optionsList].forEach((option, index, arr) => {
          tagsWrapWidth += Number(option.clientWidth) + 10;
          if (tagsWrapWidth > tagsWidth) {
            this.displayLimit = index;
            arr.length = index + 1;
          }
        });
        if ([...optionsList].length === 0) this.displayLimit = 99999;
      },
      deep: true,
    },
    newValues(users) {
      const newUsers = users.filter((user) => {
        const isInValues = this.values.some(({ value }) => value === user.value);
        const isInOptions = this.options.some(({ value }) => value === user.value);
        return !isInValues && isInOptions;
      });
      this.values = [...this.values, ...newUsers];
    },
  },
  mounted() {
    if (this.initValues) {
      this.values = this.initValues;
    }
  },
  methods: {
    handleChoseValue({ optionValue, checkboxValue }) {
      if (checkboxValue) {
        const filteredValues = this.values.filter(({ value }) => value !== optionValue.value);
        this.values = filteredValues;
      } else {
        this.values = [...this.values, optionValue];
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
::v-deep .col-form-label {
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  padding-bottom: 8px;
}
::v-deep .multiselect {
  &.multiselect--active.chosen-values {
    margin-bottom: -36px;
    .multiselect__tags {
      .multiselect__input {
        margin-top: 16px;
      }
    }
  }
  .multiselect__tags {
    border: 1px solid #c5d0de;
    border-radius: 4px;
    font-size: 16px;
    padding: 12px 40px 12px 12px;
    display: flex;
    flex-wrap: wrap;
    .multiselect__tags-wrap {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      align-items: center;
      margin-top: -7px;
      margin-bottom: -7px;
      .multiselect__tag {
        margin-top: 0;
        margin-bottom: 0;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: #2260ff;
        background-color: inherit;
        border: 1px solid #2260ff;
        border-radius: 4px;
        padding: 8px;
        padding-right: 24px;
        & > span {
          padding-right: 8px;
          border-right: 1px solid #c5d0de;
        }
        .multiselect__tag-icon {
          width: 24px;
        }
        .multiselect__tag-icon:after {
          color: #2260ff;
          font-weight: 200;
          font-size: 16px;
          line-height: 32px;
        }
        .multiselect__tag-icon:hover {
          background-color: inherit;
          &::after {
            font-weight: 500;
          }
        }
      }
    }
    .multiselect__strong {
      background: #2260ff;
      border-radius: 4px;
      padding: 8px;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: #fff;
      margin-top: -7px;
      margin-bottom: -7px;
    }
    .multiselect__input {
      padding: 0;
      display: flex;
      align-items: center;
      margin-bottom: 0;
      font-size: 16px;
      line-height: 20px;
    }
  }
  .multiselect__select {
    height: 100%;
    padding: 0;
    background: url('../../../../assets/icons/arrow_down.svg') no-repeat scroll;
    background-position: center center;
    &::before {
      display: none;
    }
  }
  .multiselect__placeholder {
    display: flex;
    align-items: center;
    padding-left: 0;
    margin-bottom: 0;
    padding-top: 0;
    font-size: 16px;
    line-height: 20px;
  }
  .multiselect__option--selected {
    background: inherit;
    color: inherit;
  }
  .multiselect__option--highlight {
    background: #f5f7f9;
    color: inherit;
  }
  .multiselect__option::after {
    display: none;
  }
  .multiselect__option {
    padding: 8px 12px 4px;
  }
  .multiselect__content-wrapper {
    border: none;
    box-shadow: -1px -1px 16px rgba(15, 32, 65, 0.04), 1px 1px 12px rgba(15, 32, 65, 0.04);
    .multiselect__content {
      padding: 8px 0;
      width: inherit;
      .multiselect-checkbox .checkbox .custom-control-label {
        cursor: pointer;
        overflow-x: hidden;
        > span {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
}
.multiselect-option.focused {
  color: #16181b;
  text-decoration: none;
  background-color: #e9ecef;
}

.multiselect-option.selected {
  font-weight: bold;
}

::v-deep .single-wrapper {
  display: flex;
  height: 29px;
  justify-content: center;
  align-items: center;
  padding-top: 1px;
  overflow: hidden;
  position: absolute;
  width: 80%;
}
::v-deep .single-wrapper-text {
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
  white-space: nowrap;
}

::v-deep .multiselect__single {
  display: none;
}

.input-label-focus {
  font-size: 12px !important;
  top: -8px !important;
  line-height: 15px;
}
.input-label-focus-color {
  color: #80bdff !important;
}

.input-label-error {
  color: #dc3545 !important;
}

.input-label {
  position: absolute;
  left: 10px;
  color: #80868b;
  top: 6px;
  font-size: 14px;
  background: white;
  padding: 0 5px;
  transition: all 0.2s ease-out;
  z-index: 2;
}

.wrapper {
  display: flex;
}

.text-input-group {
  position: relative;
  margin-bottom: 35px;
}

.error-message {
  position: absolute;
  top: 32px;
  color: #dc3545;
  white-space: nowrap;
}

.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: none !important;
  outline: 0;
  box-shadow: none !important;
}

.input-label-focus-hide {
  opacity: 0;
}

.text-input-group.require-field,
.text-input-group.is-invalid {
  color: #ed3232;
}
</style>
